import React, { useEffect, useState } from 'react';
import { useNavigate, useLocation } from 'react-router-dom';
import { getEvent } from '../../firebase';
import { Event } from '../../types';
import { CheckCircleIcon } from '@heroicons/react/24/outline';

const RegistrationSuccess: React.FC = () => {
  const navigate = useNavigate();
  const location = useLocation();
  const [event, setEvent] = useState<Event | null>(null);
  const [loading, setLoading] = useState(true);
  
  useEffect(() => {
    const loadEventDetails = async () => {
      // Get event ID from query parameters
      const params = new URLSearchParams(location.search);
      const eventId = params.get('event');
      
      if (!eventId) {
        navigate('/events');
        return;
      }
      
      try {
        const eventData = await getEvent(eventId);
        setEvent(eventData);
      } catch (error) {
        console.error('Error fetching event details:', error);
      } finally {
        setLoading(false);
      }
    };
    
    loadEventDetails();
  }, [location.search, navigate]);
  
  if (loading) {
    return (
      <div className="flex justify-center items-center min-h-[400px]">
        <div className="animate-spin rounded-full h-12 w-12 border-t-2 border-b-2 border-blue-500"></div>
      </div>
    );
  }
  
  return (
    <div className="container mx-auto max-w-2xl px-4 py-12">
      <div className="bg-white shadow-lg rounded-lg p-8 text-center">
        <div className="flex justify-center mb-6">
          <CheckCircleIcon className="h-20 w-20 text-green-500" />
        </div>
        <h1 className="text-3xl font-bold mb-4">Registration Complete!</h1>
        
        {event && (
          <div className="mb-6">
            <p className="text-xl mb-4">
              Thank you for registering for <span className="font-semibold">{event.title}</span>
            </p>
            <div className="bg-gray-50 p-4 rounded-lg text-left">
              <p className="font-medium mb-2">Event Details:</p>
              <p className="mb-2">
                <span className="text-gray-600">Date:</span> {event.date}
              </p>
              <p className="mb-2">
                <span className="text-gray-600">Time:</span> {event.time}
              </p>
              <p>
                <span className="text-gray-600">Location:</span> {event.location}
              </p>
            </div>
          </div>
        )}
        
        <p className="mb-6">
          A confirmation email has been sent with your ticket information.
        </p>
        
        <div className="flex flex-col md:flex-row space-y-4 md:space-y-0 md:space-x-4 justify-center">
          <button
            onClick={() => navigate('/portal/events')}
            className="bg-blue-500 hover:bg-blue-600 text-white px-6 py-2 rounded-md"
          >
            Back to Events
          </button>
          <button
            onClick={() => navigate('/portal/tickets')}
            className="bg-gray-200 hover:bg-gray-300 text-gray-800 px-6 py-2 rounded-md"
          >
            View My Tickets
          </button>
        </div>
      </div>
    </div>
  );
};

export default RegistrationSuccess; 